export const maintenanceWorkflowsTableColumns = [
  { value: 'protocol_number', label: 'Número de protocolo' },
  { value: 'status', label: 'Status' },
  { value: 'current_forwarding', label: 'Encaminhamento atual' },
  { value: 'equipment', label: 'Equipamento' },
  { value: 'company', label: 'Empresa' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
